import React from "react";
import { connect } from "react-redux";
import "./audio-tagV2.css";
import { injectIntl } from "react-intl";
import classNames from "classnames";
import AudioIconDart from "../../../assets/icons/audio_dart.svg";

class AudioTagV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onClickHandler = () => {
    const { onClick, versionNumber, time, intl } = this.props;
    // , intl
    if (onClick) {
      onClick(versionNumber, time, versionNumber, intl);
    }
  };

  secondsToString(seconds) {
    var hour = Math.floor(seconds / 3600);
    hour = (hour < 10)? '0' + hour : hour;
    var minute = Math.floor((seconds / 60) % 60);
    minute = (minute < 10)? '0' + minute : minute;
    var second = seconds % 60;
    second = (second < 10)? '0' + second : second;
    if (hour === '00') {
      return minute + ':' + second;
    } else {
      return hour + ':' + minute + ':' + second;
    }
  }

  render() {
    // const { time, minutes, onClick } = this.props;
    const { time, versionNumber, onClick } = this.props;
    let classes = classNames({
      'audioFile': true,
      "cursor-pointer": onClick ? true : false
    });
    const timeString = this.secondsToString(time);
    return (
      <React.Fragment>
        <p className={classes} onClick={this.onClickHandler}>
          <img src={AudioIconDart} alt="img" className='video-tag-icon' />
          {timeString} v.{versionNumber}
        </p>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default injectIntl(connect(mapStateToProps, null)(AudioTagV2));
